export default function Speaker() {
  return (
    <section className="section speaker-section" id="yahir">
      <div className="container speaker-layout">
        <div className="speaker-visual">
          <img
            className="portrait-photo"
            src="https://media-manager-c.questera.ai/greta-media/8a42d99e806f64b1f0dfa735fed43e80ede8700e567960152a8609ec46fb6f4f2e2369410146691921b872e35dfaeaea/images/aW1hZ2UvcG5n/557bf85af6cc125cc88158cff63168a4.png"
            alt="Yahir Pérez"
          />
        </div>
        <div className="speaker-copy">
          <span className="eyebrow">02 / EL PONENTE</span>
          <h2>Conoce a<br /><em>Yahir Pérez.</em></h2>
          <span className="gold-stroke" />
          <p>
            Yahir Pérez creció dentro de este negocio. Hijo de una distribuidora,
            pasó de una vida sin rumbo a construir Team Totolcingo y a cumplir la
            promesa de llevar a sus padres al reconocimiento como Equipos del
            Presidente.
          </p>
          <p>
            No enseña desde la teoría. Enseña prospección, hábitos y sistema con
            la crudeza de quien lo vivió. Líderes con más de veinte años de
            trayectoria califican sus entrenamientos como magistrales.
          </p>
          <div className="speaker-signature">
            EXPERIENCIA REAL. ENSEÑANZA DIRECTA.
          </div>
        </div>
      </div>
    </section>
  );
}